/** Settings › Projects: project list, project details, folders, Git and dev server. */
export default {
  unavailable: "This project or folder is unavailable.",
  projects: "Projects",
  loadingProjects: "Loading projects…",
  projectsLoadError: "Couldn’t load projects.",
  noProjects: "No projects yet.",
  creating: "Creating…",
  newProject: "New project",
  create: "Create",
  createProjectError: "Couldn’t create project.",
  foldersAfterCreate: "You can add folders once the project is created.",
  saved: "Saved",
  discardChangesTitle: "Discard changes?",
  discardChangesDescription: "Your changes to this project aren’t saved.",
  discard: "Discard",

  enterProjectName: "Enter a project name.",
  updateProjectError: "Couldn’t update project.",
  name: "Name",
  projectName: "Project name",
  description: "Description",
  colour: "Colour",
  homeProjectColour: "Home project colour",
  folders: "Folders",
  folder: "Folder",
  addFolder: "Add folder",
  account: "Account",
  archiveProject: "Archive project",
  openProject: "Open project",
  archiveProjectTitle: "Archive project?",
  archiveProjectDescription: "The project will leave your active projects.",
  archive: "Archive",

  enterFolderPath: "Enter a folder path.",
  folderAlreadyAdded: "This folder is already in the project.",
  addFolderError: "Couldn’t add folder.",
  folderPath: "Folder path",
  labelOptional: "Label (optional)",
  adding: "Adding…",

  accessAllowed: "Allowed",
  accessNotAllowed: "Not allowed",
  accessNotChecked: "Not checked",
  copyPathError: "Couldn’t copy the path.",
  removeFolderError: "Couldn’t remove folder.",
  copyPath: "Copy path",
  folderAccess: "Folder access",
  checking: "Checking…",
  grantAccess: "Grant access",
  checkAgain: "Check again",
  repository: "Repository",
  notConfigured: "Not configured",
  devServer: "Dev server",
  removeFolder: "Remove folder",
  removeFolderTitle: "Remove folder?",
  removeFolderDescription:
    "Remove this folder from the project. Files on your computer are kept.",
  checkAccessError: "Couldn’t check folder access.",
  openAccessSettingsError: "Couldn’t open access settings.",

  updateGitError: "Couldn’t update Git settings.",
  gitRepository: "Git repository",
  repositoryUrl: "Repository URL",
  defaultBaseBranch: "Default base branch",
  branchPrefix: "Branch prefix",
  prTarget: "PR target",
  sameAsBase: "Same as base",
  branchNameTemplate: "Branch name template",

  confirmDevServerError: "Couldn’t confirm dev server.",
  prepareCommand: "Prepare command",
  runCommand: "Run command",
  readyCheck: "Ready check",
  readyCheckPlaceholder: "Optional path or regex",
  confirmHint:
    "Confirm these settings for your agents. This does not start the server.",
  confirming: "Confirming…",
  confirmed: "Confirmed",
  markConfirmed: "Mark as confirmed",
} as const;
